/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { useErrorHandler } from 'react-error-boundary';

import MoveTop from '../../CommonParts';
import { savePlace } from '../../redux_toolkit/reserveChangeSlice';
// import receptionRegister from '../../api/reception/receptionRegister';
import placeMasta from '../../api/masta/placeMasta';
import { useDidMount } from '../../customHooks';
import TopicPath from '../../components/TopicPath';

import rsvSettingMasta from '../../api/masta/rsvSettingMasta';
import { dispTellStartPeople } from '../../utils';
import { ReserveHeader } from '../../components/Header';
import { Footer } from '../../components/Footer';

import {
  HOME_ONLY,
  FACILITY_ONLY,
  HOME_AND_FACILITY,
  PHONE_ONLY,
  HOME_AND_PHONE,
  FACILITY_AND_PHONE,
  HOME_FACILITY_AND_PHONE,
  RSV_FLAG_HOME,
  RSV_FLAG_FACILITY,
  RSV_FLAG_PHONE,
  CANCEL_CHANGE_ANNOUNCE,
  DEFAULT_PLACE_SELECT_DESC,
  DEFAULT_WEB_WINDOW_DESC,
  DEFAULT_FACILITY_SELECT_DESC,
  DEFAULT_CALL_SELECT_DESC,
  DEFAULT_HOME_USE_LABEL,
} from '../../constants';
import ChangeSelectionSummary from '../../components/ChangeSelectionSummary';

const ChangePlace = function () {
  const navigate = useNavigate();
  const handleError = useErrorHandler();

  const lgCd = useSelector((state) => state.reserveChange.lgCd);
  const rsvConfig = useSelector((state) => state.rsvConfig);
  const { topicPath = [], rsvMode, rsvPlaceIds, rsvTelPlaceIds, locationSetting = {} } = rsvConfig;

  const placeSelectDesc =
    locationSetting?.place_select_screen?.place_select_desc || DEFAULT_PLACE_SELECT_DESC;
  const webWindowDesc =
    locationSetting?.place_select_screen?.web_window_desc || DEFAULT_WEB_WINDOW_DESC;
  const facilitySelectDesc =
    locationSetting?.place_select_screen?.facility_select_desc || DEFAULT_FACILITY_SELECT_DESC;
  const callSelectDesc =
    locationSetting?.place_select_screen?.call_select_desc || DEFAULT_CALL_SELECT_DESC;
  const homeUseLabel = locationSetting?.item_label?.home_use || DEFAULT_HOME_USE_LABEL;

  const rsvSetId = useSelector((state) => state.reserveChange.rsvSetId);
  const chUrl = useSelector((state) => state.reserveChange.url);
  const businessChanged = useSelector((state) => state.reserveChange.businessChanged);
  // 元の予約日以外の日付を選択済みかどうか
  const dateChanged = useSelector((state) => state.reserveChange.dateChanged);

  const dispatch = useDispatch();

  const [places, setPlaces] = useState([]);
  const [telPlaces, setTelPlaces] = useState([]);
  const [pageName, setPageName] = useState('');
  const [backUrl, setBackUrl] = useState('');

  const [tellStartFlag, setTellStartFlag] = useState(1);

  const getPlaces = async () => {
    // 利用場所の取得
    try {
      // 自宅利用のみの場合は画面をスキップして次へ
      if (rsvMode === null || rsvMode === HOME_ONLY) {
        dispatch(
          savePlace({
            id: '',
            name: '',
            address: '',
            subAddress: '',
            tel: '',
            useHome: true,
            rsvFlag: RSV_FLAG_HOME,
          })
        );
        navigate('/change/date');
        return;
      }

      const { places: fetchedPlaces, telPlaces: fetchedTelPlaces } = await placeMasta.getUsePlaces(
        rsvPlaceIds,
        rsvTelPlaceIds
      );
      setPlaces(fetchedPlaces);
      setTelPlaces(fetchedTelPlaces);
    } catch (err) {
      window.alert('利用場所取得に失敗しました。');
      handleError(err);
    }
  };

  // パンくずリスト設定から、ページ名・前の画面のURLをstateに設定
  const getBackUrlAndPageName = (topicPathConf) => {
    const locationPath = window.location.pathname;
    const tmpPath1 = locationPath.replace('/reserve/', '');
    const tmpPath2 = tmpPath1.replace('/test', '');
    const currentPath = tmpPath2.replace('/demo', '');

    let backUrl = '';
    let scnName = '';
    for (let i = 0; i < topicPathConf.length; i += 1) {
      const { url = '', scnName: tmpScnName = '' } = topicPathConf[i];
      if (currentPath === url) {
        // 「前に戻る」先のURL取得
        const { url: tmpBackUrl = '' } = topicPathConf[i - 1];
        if (tmpBackUrl === 'change/:url') {
          // ChangeOrCancel は change/:url というプレースホルダーなので実際の changeUrl に置き換える
          backUrl = `change/${chUrl}`;
        } else if (tmpBackUrl === '/:lgCd') {
          backUrl = lgCd;
        } else {
          backUrl = tmpBackUrl;
        }

        // pageNameを取得
        scnName = tmpScnName;

        break;
      }
    }

    setPageName(scnName);
    setBackUrl(backUrl);
  };

  const init = async () => {
    // ページ名/戻る先URLの取得
    getBackUrlAndPageName(topicPath);

    // 表示する用件情報の取得
    getPlaces();
  };

  // 予約設定を取得
  const getRsvSetting = async () => {
    try {
      // 自宅利用のみの場合は必要ないので取得しない
      if (rsvMode !== null && rsvMode !== HOME_ONLY) {
        const result = await rsvSettingMasta.getRsvSetting(rsvSetId);
        const { tell_start: tellStart = 1 } = result;
        setTellStartFlag(parseInt(tellStart, 10));
      }
    } catch (err) {
      window.alert('予約設定の取得に失敗しました。');
      handleError(err);
    }
  };

  useDidMount(() => {
    init();
    getRsvSetting();
  });

  const onClickBack = () => {
    if (backUrl) {
      navigate(`/${backUrl}`, { state: { cameFromBack: true } });
    } else {
      navigate(-1);
    }
  };

  const onClickPlace = (place, rsvFlag) => {
    const { id = '', name = '', address = '', subAddress = '', tel = '' } = place;
    dispatch(
      savePlace({ id, name, address, subAddress, tel, useHome: false, rsvFlag, numOfAttendees: 0 })
    );
    navigate('/change/date');
  };

  const createPlaceList = (places, rsvFlag) => {
    const list = [];
    for (let i = 0; i < places.length; i += 1) {
      const { id = '', name = '', address = '', subAddress = '', tel = '' } = places[i];
      list.push(
        <li className="mb30 w100">
          <div className="row">
            <div className="w100">
              <label
                htmlFor={`tab_place_${rsvFlag}_${id}`}
                style={{
                  border: `2px solid rgb(40,117,232)`,
                }}
              >
                {name}
                <input
                  type="checkbox"
                  id={`tab_place_${rsvFlag}_${id}`}
                  onClick={() => {
                    onClickPlace(places[i], rsvFlag);
                  }}
                />
              </label>
            </div>
          </div>
          <div>
            {`${address} ${subAddress}`}
            {address && tel ? <br /> : null}
            {tel ? `TEL: ${tel}` : ''}
            <br />
            {rsvFlag === RSV_FLAG_PHONE ? dispTellStartPeople(tellStartFlag) : null}
          </div>
        </li>
      );
    }
    return list;
  };

  // const getAttribute = (funcCd) => attribute[funcCd] ?? {};
  return (
    <>
      <ReserveHeader servCd="reserve" lgCd={lgCd} />
      <div id="container">
        <TopicPath />
        <main>
          <article>
            {/* 用件変更あり or 日付変更あり のとき日時を隠す。どちらも変更なしのときは変更前情報を表示する */}
            <ChangeSelectionSummary
              hidePlace={businessChanged}
              hideDatetime={businessChanged || dateChanged}
            />
            <div id="contents">
              <MoveTop lgCd={lgCd} />
              <div className="inner txtCenter">
                <div className="shrinkSizeOnPc">
                  {/* <h2>STEP 2 利用場所の選択</h2> */}
                  <h2>{pageName}</h2>

                  {/* mode1: 通常の場所選択 */}
                  <h3 className="txtCenter mb20">{placeSelectDesc}</h3>
                  {rsvMode !== null &&
                  [HOME_ONLY, HOME_AND_FACILITY, HOME_AND_PHONE, HOME_FACILITY_AND_PHONE].includes(
                    rsvMode
                  ) ? (
                    <>
                      <p className="txtBold">{webWindowDesc}</p>
                      <div className="tabContent" style={{ display: 'block' }}>
                        <ul className="wrap" style={{ listStyle: 'none' }}>
                          <li className="w100">
                            <label
                              htmlFor="tab_home"
                              style={{
                                border: `2px solid rgb(40,117,232)`,
                              }}
                            >
                              {homeUseLabel}
                              <input
                                type="checkbox"
                                id="tab_home"
                                onClick={() => {
                                  dispatch(
                                    savePlace({
                                      id: '',
                                      name: '',
                                      address: '',
                                      subAddress: '',
                                      tel: '',
                                      useHome: true,
                                      rsvFlag: RSV_FLAG_HOME,
                                    })
                                  );
                                  navigate('/change/date');
                                }}
                              />
                            </label>
                          </li>
                        </ul>
                      </div>
                    </>
                  ) : null}
                  {rsvMode !== null &&
                  [
                    FACILITY_ONLY,
                    HOME_AND_FACILITY,
                    FACILITY_AND_PHONE,
                    HOME_FACILITY_AND_PHONE,
                  ].includes(rsvMode) ? (
                    <>
                      <p className="txtBold">{facilitySelectDesc}</p>
                      <div className="tabContent" style={{ display: 'block' }}>
                        <ul className="wrap" style={{ listStyle: 'none' }}>
                          {createPlaceList(places, RSV_FLAG_FACILITY)}
                        </ul>
                      </div>
                    </>
                  ) : null}
                  {rsvMode !== null &&
                  [
                    PHONE_ONLY,
                    HOME_AND_PHONE,
                    FACILITY_AND_PHONE,
                    HOME_FACILITY_AND_PHONE,
                  ].includes(rsvMode) ? (
                    <>
                      <p className="txtBold">{callSelectDesc}</p>
                      <div className="tabContent" style={{ display: 'block' }}>
                        <ul className="wrap" style={{ listStyle: 'none' }}>
                          {createPlaceList(telPlaces, RSV_FLAG_PHONE)}
                        </ul>
                      </div>
                    </>
                  ) : null}
                  <ul id="navi" className="row jcSB">
                    <li className="col2">
                      <a
                        role="button"
                        onClick={() => onClickBack()}
                        className="btn btBack"
                        tabIndex={0}
                      >
                        前に戻る
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
              <div className="cancelAnnounce">{CANCEL_CHANGE_ANNOUNCE}</div>
            </div>
          </article>
        </main>
      </div>
      <Footer />
    </>
  );
};

export default ChangePlace;
